//@flow
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CallToAction } from 'components/atoms/callToAction';
import { Image } from 'components/atoms/image';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

type Props = {
  heading: string,
  content: string,
  imageData: string,
};

const ImageInfoModuleMobile = (props: Props) => {
  const { height } = useViewport();
  const {
    heading,
    content,
    imageData,
    buttonName,
    onClickButton,
    togglePadding,
  } = props;

  return (
    <div
      className={
        togglePadding
          ? 'image-info-module-mobile no-padding-top'
          : 'image-info-module-mobile'
      }
      style={{ height }}
    >
      <div className={'inner-section-mobile'}>
        <Row className={'inner-row'}>
          <Col xs={{ span: 6 }}>
            <h2 style={{ width: '107%' }}>{heading}</h2>
          </Col>
          <Col xs={{ span: 12 }}>
            <p className={'content'}>{content}</p>
          </Col>
        </Row>
        {buttonName && (
          <div className={'explore'}>
            <CallToAction
              text={buttonName}
              mode={'transparent'}
              type={'link'}
              onClick={e => onClickButton(true)}
              size={'small'}
              isMobile={'true'}
            />
          </div>
        )}
        <div className={'image-section'}>
          <Image src={imageData} alt={'media'} />
        </div>
      </div>
    </div>
  );
};

export default ImageInfoModuleMobile;
